<template>
<div class="instructions-carousel" id="instructions-carousel" :style="{ left: -100 * activeSlideIndex + '%' }">
  <div
    v-for="(slide, index) in instructions.carousel.slides"
    :key="index"
    class="carousel-item"
  >
    <div class="carousel-content-container" id="carousel-content-container">
      <p
        v-if="slide.title || slide.titleTx"
        class="instruction-page-title"
        :name="`${instructions.currentStep}_carousel_title`"
        :id="`${instructions.currentStep}_carousel_title`"
      >{{ slide.titleTx ? $t(slide.titleTx) : slide.title }}</p>

      <BaseResource
        v-if="slide.resource"
        :instructions="slide"
      />

      <div class="page-content">
        <p
          v-if="slide.primaryText || slide.primaryTx"
          class="instruction-title"
          :name="`${instructions.currentStep}_carousel_primaryText`"
          :id="`${instructions.currentStep}_carousel_primaryText`"
        >{{ slide.primaryTx ? $t(slide.primaryTx) : slide.primaryText }}</p>
        <p
          :name="`${instructions.currentStep}_carousel_secondaryText`"
          :id="`${instructions.currentStep}_carousel_secondaryText`"
          :class="['instruction-subtitle', slide.additionalSecondaryTextClasses]"
        >{{ slide.secondaryTx ? $t(slide.secondaryTx) : slide.secondaryText }}</p>

        <BaseSteps
          v-if="slide.steps && slide.steps.length > 0"
          :instructions="slide"
          :brandTheme="brandTheme"
        />
      </div>

      <CarouselFooter
        @onBack="prevSlide"
        @onNext="nextSlide"
        :instructions="instructions"
        :slideIndex="activeSlideIndex"
      />
    </div>
  </div>
</div>
</template>

<script>
import BaseSteps from './BaseSteps.vue';
import BaseResource from './BaseResource.vue';
import CarouselFooter from './CarouselFooter.vue';

export default {
  name: 'BaseCarousel',
  components: {
    BaseResource,
    BaseSteps,
    CarouselFooter,
  },
  data() {
    return {
      activeSlideIndex: 0,
    }
  },
  methods: {
    nextSlide() {
      if (this.activeSlideIndex === this.instructions.carousel.slides.length - 1) {
        if (this.instructions.isLastPage) {
          window.location.href = this.instructions.lastPageExitUrl;
        } else {
          this.$router.push({
            name: this.instructions.nextStepName,
            params: {
              brand: this.$route.params.brand,
              device: this.$route.params.device,
              step: this.instructions.nextStep
            }
          });
        }
      } else {
        this.activeSlideIndex += 1;
      }
    },
    prevSlide() {
      if ((this.activeSlideIndex - 1) < 0) {
        return;
      }
      this.activeSlideIndex -= 1;
    }
  },
  props: {
    instructions: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
.instructions-carousel {
  position: relative;
  width: 1000%;
  height: 100%;
  overflow: hidden;
  transition: right 0.3s, left 0.3s;
  will-change: left, right;
}

.carousel-content-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.carousel-item {
  position: relative;
  float: left;
  width: 10%;
  height: 100%;
  display: inline-flex;
  align-items: flex-start;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>